<script setup>
import Cookies from 'js-cookie';
import { onMounted, ref } from 'vue';
import apiClient from '../libs/api.js';

const csrftoken = ref(Cookies.get('csrftoken'));

onMounted(async () => {
  // cookie should be populated by App.vue, but just in case
  // we populate it again here to avoid weird edge cases
  await apiClient.populateCSRFToken();
  csrftoken.value = Cookies.get('csrftoken');
});

</script>

<template>
  <div class="min-h-screen flex flex-col items-center justify-center ">
    <div class="bg-gray-800 mb-4 p-4 rounded-lg ">
      <div class="  flex justify-center">
        <!-- Logo -->
        <a href="/" class="flex  mr-4">
          <span class="self-center ml-4 mb-1 ">
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 229 235" version="1.1">
              <path
                d="M 22 103.477 C 22 147.765, 22.337 183.999, 22.750 183.999 C 23.163 183.998, 25.565 181.860, 28.090 179.249 C 30.614 176.637, 47.898 158.075, 66.497 138 C 85.097 117.925, 103.056 98.564, 106.407 94.975 C 109.758 91.386, 125.775 74.129, 142 56.626 C 158.225 39.123, 171.656 24.380, 171.846 23.863 C 172.057 23.291, 162.784 22.990, 148.100 23.093 C 124.832 23.257, 123.931 23.337, 121.754 25.439 C 120.514 26.636, 115.900 31.427, 111.500 36.086 C 107.100 40.745, 93.375 55.519, 81 68.916 L 58.500 93.274 58 58.387 L 57.500 23.500 39.750 23.227 L 22 22.954 22 103.477"
                stroke="none" fill="#fe0000" fill-rule="evenodd" />
              <path
                d="M 69 156.645 C 47.825 179.506, 28.587 200.291, 26.250 202.834 L 22 207.456 22 216.728 L 22 226 40 226 L 58 226 58.008 211.750 L 58.015 197.500 74.136 180.179 C 83.003 170.652, 90.620 163.227, 91.064 163.679 C 91.507 164.130, 97.862 171.327, 105.185 179.671 C 112.508 188.015, 124.575 201.817, 132 210.342 L 145.500 225.841 175.405 225.920 C 203.790 225.996, 205.234 225.911, 203.822 224.250 C 203.004 223.287, 194.046 213.078, 183.917 201.562 C 173.788 190.046, 162.140 176.771, 158.034 172.062 C 153.927 167.353, 141.821 153.600, 131.131 141.500 C 120.442 129.400, 110.752 118.505, 109.598 117.289 L 107.500 115.079 69 156.645"
                stroke="none" fill="#E5E7EB" fill-rule="evenodd" />
            </svg>
          </span>
          <span class="self-center   text-3xl font-semibold whitespace-nowrap dark:text-gray-200">awaix</span>
        </a>
      </div>
      <div class="  flex justify-center mt-6">
        <!-- Google Sign in -->
        <form method="post" action="/accounts/google/login/" class="mb-4 w-64 justify-center flex">
          <input type="hidden" name="csrfmiddlewaretoken" v-model="csrftoken">
          <button type="submit"
            class="text-white bg-[#4285F4] hover:bg-[#4285F4]/90 focus:ring-4 focus:outline-none focus:ring-[#4285F4]/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-[#4285F4]/55 mr-2 mb-2">
            <svg class="w-4 h-4 mr-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
              viewBox="0 0 18 19">
              <path fill-rule="evenodd"
                d="M8.842 18.083a8.8 8.8 0 0 1-8.65-8.948 8.841 8.841 0 0 1 8.8-8.652h.153a8.464 8.464 0 0 1 5.7 2.257l-2.193 2.038A5.27 5.27 0 0 0 9.09 3.4a5.882 5.882 0 0 0-.2 11.76h.124a5.091 5.091 0 0 0 5.248-4.057L14.3 11H9V8h8.34c.066.543.095 1.09.088 1.636-.086 5.053-3.463 8.449-8.4 8.449l-.186-.002Z"
                clip-rule="evenodd" />
            </svg>
            Sign in with Google
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

